import type { FC } from 'react';
import { Navigation, Pagination } from 'swiper/modules';
import Slider from '@/DesignSystem/Component/Slider/Slider';
import { LessonSection } from '@/Module/Lesson/Component';
import type { ILessonSection } from '@/Module/Lesson/Model/DataModel';
interface ILatestLessonSliderProps {
  ids: ILessonSection['id'][];
}
const LatestLessonSlider: FC<ILatestLessonSliderProps> = ({
  ids
}) => {
  return <Slider id="LatestLessonSlider" pagination={{
    bulletClass: `lg:!hidden`
  }} color="primary" modules={[Navigation, Pagination]} className="relative !pr-4" breakpoints={{
    640: {
      slidesPerView: 1,
      spaceBetween: 20
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 40
    },
    1280: {
      slidesPerView: 4,
      spaceBetween: 40
    }
  }} data-sentry-element="Slider" data-sentry-component="LatestLessonSlider" data-sentry-source-file="LatestLessonSlider.tsx">
      {ids.map((id, index) => <LessonSection id={id} key={id} className="mb-4" index={index + 1} isSummary isTeacher />)}
    </Slider>;
};
export default LatestLessonSlider;